import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiServiceService } from 'src/app/_service/api-service.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-mentor-volunteer',
  templateUrl: './mentor-volunteer.component.html',
  styleUrls: ['./mentor-volunteer.component.scss']
})
export class MentorVolunteerComponent implements OnInit {

  createCourseForm: FormGroup;
  users: any = JSON.parse(localStorage.getItem('login_user_details'));
  sessions: any = [];
  currentSession: session = {id: 0, mentor_id: 0, fromDate: '', toDate: '', fromTime: '', toTime: ''};

  constructor(private fb: FormBuilder, private apiService: ApiServiceService, private router: Router) {
    this.createCourseForm = this.fb.group({
      fromDate: ['', Validators.required],
      toDate: ['', Validators.required],
      fromTime: ['', Validators.required],
      toTime: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.apiService.getVolunteer(this.users.id).pipe().subscribe((response) => {
      if (response) {
        console.log('Response:', response);
        this.sessions = response;
      }
    });
  }

  editCourse(session) {
    console.log('Edit session:', session);
    this.currentSession = session;

    this.createCourseForm.patchValue({
      fromDate: session.fromDate,
      toDate: session.toDate,
      fromTime: session.fromTime,
      toTime: session.toTime,
    });
  }

  deleteCourse(session) {
    this.apiService.deleteVolunteer(session.id).pipe().subscribe((response) => {
      if (response) {
        console.log('Response:', response);
       // location.reload();
      }
    });
    console.log('Delete session:', session);
  }

  openCreateForm() {
    this.createCourseForm.reset();
    this.currentSession = {id: 0, mentor_id: 0, fromDate: '', toDate: '', fromTime: '', toTime: ''};
    // Open the modal
    //$('#createCourseModal').modal('show');
  }

  createCourse() {
    if (this.createCourseForm.invalid) {
      this.createCourseForm.markAllAsTouched();
      return;
    }

    if (this.currentSession.id > 0) {
      this.currentSession.fromDate = this.createCourseForm.value.fromDate;
      this.currentSession.toDate = this.createCourseForm.value.toDate;
      this.currentSession.fromTime = this.createCourseForm.value.fromTime;
      this.currentSession.toTime = this.createCourseForm.value.toTime;
      this.currentSession.mentor_id = this.users.id;
      console.log(this.currentSession);

      this.apiService.updateVolunteer(this.currentSession).pipe().subscribe((response) => {
        if (response) {
          console.log('Response:', response);
          location.reload();
        }
      });
    } else {
      this.currentSession = this.createCourseForm.value;
      this.currentSession.mentor_id = this.users.id;
      console.log(this.currentSession);

      this.apiService.createVolunteer(this.currentSession).pipe().subscribe((response) => {
        if (response) {
          console.log('Response:', response);
          location.reload();
        }
      });
    }
  }
}

interface session {
  id: number;
  mentor_id: number;
  fromDate: string;
  toDate: string;
  fromTime: string;
  toTime: string;
}